import React, { useState, ChangeEvent } from 'react';
import './App.css';
import coulombuvZakon from './coulomb.jpg'

const App = () => {

  // Coulombův zákon
  const[Q1,setQ1]=useState<number>(1);
  const[Q2,setQ2]=useState<number>(1);
  const[r,setR]=useState<number>(1);
  const[permitivitaProstredi,setPermitivitaProstredi]=useState<number>(1.00054);

  // Závislost odporu na teplotě ϑ
  const[l,setL]=useState<number>(1);
  const[S,setS]=useState<number>(1);
  const[t,setT]=useState<number>(20);
  const[rezistivita,setRezistivita]=useState<number>(0.0178);
  const[R20,setR20]=useState<number>(0.0178);
  const[tepSoucElOdporu,setTepSoucElOdporu]=useState<number>(4.0);

  const handleChangeCoulomb = (event: ChangeEvent<HTMLInputElement>): void => {

    switch (event.target.name) {
		  case 'Q1':
        const valueQ1 = Number(event.target.value);
			  setQ1(valueQ1);
			  break;
		  case 'Q2':
			  const valueQ2 = Number(event.target.value);
			  setQ2(valueQ2);
			  break;
		  case 'r':
			  const valueR = Number(event.target.value);
			  setR(valueR);
			  break; 
		  case 'permitivitaProstredi':
			  const valuePermitivitaProstredi = Number(event.target.value);
			  setPermitivitaProstredi(valuePermitivitaProstredi);
			  break;
		  default:
			  break;
		};

  }

  const handleChangeZavOdpNaTep = (event: ChangeEvent<HTMLInputElement>): void => {

    

    switch (event.target.name) {
		  case 'l':
        const valueL = Number(event.target.value);
			  setL(valueL);
        setR20((rezistivita*valueL)/S);
			  break;
		  case 'S':
			  const valueS = Number(event.target.value);
			  setS(valueS);
        setR20((rezistivita*l)/valueS);
			  break;
		  case 't':
			  const valueT = Number(event.target.value);
			  setT(valueT);
			  break;
		  default:
			  break;
		};

  }

  const selectChangeTeplotniZavislost = (event: React.ChangeEvent<HTMLSelectElement>) => {

    switch (event.target.value) {
		  case 'Měď':
        setRezistivita(0.0178);
			  setR20((0.0178*l)/S);
        setTepSoucElOdporu(4.0);
			  break;
		  case 'Hliník':
        setRezistivita(0.0285);
			  setR20((0.0285*l)/S);
        setTepSoucElOdporu(4.0);
			  break;
		  case 'Stříbro':
        setRezistivita(0.0164);
			  setR20((0.0164*l)/S);
        setTepSoucElOdporu(4.1);
			  break; 
		  case 'Železo':
        setRezistivita(0.0996);
			  setR20((0.0996*l)/S);
        setTepSoucElOdporu(6.5);
			  break;
      case 'Konstantan':
        setRezistivita(0.4900);
        setR20((0.4900*l)/S);
        setTepSoucElOdporu(0.05);
        break; 
      case 'Wolfram':
        setRezistivita(0.0536);
        setR20((0.0536*l)/S);
        setTepSoucElOdporu(4.5);
        break; 
		  default:
			  break;
		};
    
  }

  var coulomb = (Q1*Q2)/(4*Math.PI*8.854*Math.pow(10, -12)*permitivitaProstredi*Math.pow(r, 2))
  var coulombUnit = "N"
  if (coulomb>1000000000) {
    coulomb = coulomb/1000000000
    coulombUnit = "GN"
  }
  else if (coulomb>1000000) {
    coulomb = coulomb/1000000
    coulombUnit = "MN"
  }
  else if (coulomb>1000) {
    coulomb = coulomb/1000
    coulombUnit = "kN"
  }
  else {
    coulombUnit = "N"
  }
  var teplotniZavislost = (R20*(1+(tepSoucElOdporu*(t-20)))).toFixed(4)

  return (
    <div className="App">

      <h1>Příklady z elektroniky</h1>
      <img src={coulombuvZakon} alt={"Coulombův zákon"} /> 
      <table>
        <tr><td colSpan={2}><h2>Coulombův zákon</h2></td></tr>
        <tr>
          <th><label title="Velikost náboje" htmlFor="Q1">Q<sub>1</sub>:</label></th>
          <td><input type="number" min="0" step="any" name="Q1" id="Q1" value={Q1} onChange={handleChangeCoulomb} />&nbsp;&nbsp;&nbsp;<text>C</text></td>
        </tr>
        <tr>
          <th><label title="Velikost náboje" htmlFor="Q2">Q<sub>2</sub>:</label></th>
          <td><input type="number" min="0" step="any" name="Q2" id="Q2" value={Q2} onChange={handleChangeCoulomb} />&nbsp;&nbsp;&nbsp;<text>C</text></td>
        </tr>
        <tr>
          <th><label title="Vzdálenost mezi náboji" htmlFor="r">r:</label></th>
          <td><input type="number" min="0" step="any" name="r" id="r" value={r} onChange={handleChangeCoulomb} />&nbsp;&nbsp;&nbsp;<text>m</text></td>
        </tr>
        <tr>
          <th><label title="Premitivita prostředí" htmlFor="permitivitaProstredi">ε<sub>r</sub>:</label></th>
          <td><input type="number" min="0" step="any" name="permitivitaProstredi" id="permitivitaProstredi" value={permitivitaProstredi} onChange={handleChangeCoulomb} /></td>
        </tr>
        <tr className="large">
					<th title='Působící síla'>F<sub>e</sub> = </th>
					<td><text>{coulomb.toFixed(2)}</text>&nbsp;&nbsp;{coulombUnit}</td>
				</tr>
        <br />
        <tr><td colSpan={2}><h2>Závislost odporu na teplotě ϑ</h2></td></tr>
        <tr>
          <th><label title="Délka vodiče" htmlFor="l">l:</label></th>
          <td><input type="number" min="0" step="any" name="l" id="l" value={l} onChange={handleChangeZavOdpNaTep} />&nbsp;&nbsp;&nbsp;<text>m</text></td>
        </tr>
        <tr>
          <th><label title="Průřez vodiče" htmlFor="S">S:</label></th>
          <td><input type="number" min="0" step="any" name="S" id="S" value={S} onChange={handleChangeZavOdpNaTep} />&nbsp;&nbsp;&nbsp;<text>mm<sup>2</sup></text></td>
        </tr>
        <tr>
          <th><label title="Teplota vodiče ϑ" htmlFor="t">ϑ:</label></th>
          <td><input type="number" min="0" step="any" name="t" id="t" value={t} onChange={handleChangeZavOdpNaTep} />&nbsp;&nbsp;&nbsp;<text>°C</text></td>
        </tr>
        <tr>
          <th title='Materiál vodiče ovlivňující jeho odporové vlastnosti'>Materiál:</th>
          <td>
            <select onChange={selectChangeTeplotniZavislost} >
              <option value="Měď">Měď</option>
              <option value="Hliník">Hliník</option>
              <option value="Stříbro">Stříbro</option>
              <option value="Železo">Železo</option>
              <option value="Konstantan">Konstantan</option>
              <option value="Wolfram">Wolfram</option>
            </select>
          </td>
        </tr>
        <tr>
					<th title='Odpor při teplotě ϑ'>R<sub>ϑ</sub> = </th>
					<td><text>{teplotniZavislost}</text>&nbsp;&nbsp;Ω</td>
				</tr>

      </table>

    </div>
  );
}

export default App;
